/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { FormattedMessage } from "react-intl";

import Modal from "../Modal";
import FileIcon from "../form-controls/FileIcon";
import formatDuration from "../../helpers/formatDuration";
import messages from "../../helpers/messages";

export const DuplicateDocumentModal = ({
  open = true,
  handleCancel,
  handleReplace,
  document
}) => {
  const fileExtension = document.fileName.substring(
    document.fileName.lastIndexOf(".") + 1
  );

  return (
    <Modal
      title={messages.duplicateDocument.defaultMessage}
      open={open}
      handleClose={handleCancel}
      titleClass="modal__title_light uppercase"
      closeButtonClass="modal__close-button mr-16 mt-16"
      bodyClass="border-top-grey pl-24 pr-24 pt-16 pb-32"
      large={true}
    >
      <p data-testid="duplicate-message" className="mb-24 font-size-16">
        {messages.duplicateDocumentModalBodyMessage.defaultMessage}
      </p>
      <div className={"t100 m-auto pt-6 pb-24"}>
        <FileIcon
          className="mx-4 my-6 grid__cell"
          fileExtension={fileExtension}
          width="18px"
          height="22px"
        />
        <div className="grid__cell t85 pl-12">
          <span className="font-bold inline-block pb-2">
            {document.fileName}
          </span>
          <div className="p4 font-size-10 color-grey">
            <span
              style={{ maxWidth: "207px" }}
              className="pr-8 truncate inline-block"
            >
              <FormattedMessage
                {...messages.uploadedByUser}
                values={{ userName: document.uploadByUserName }}
              />
            </span>
            <span className="pl-8 border-left-grey align-top">
              <FormattedMessage
                {...messages.timeSinceLastUpdateDurationAgo}
                values={{
                  timeSinceLastUpdateDurationAgo: formatDuration(
                    document.uploadDateUTC
                  )
                }}
              />
            </span>
          </div>
        </div>
      </div>
      <div className="mt-8 my-48">
        <button
          onClick={handleReplace}
          className="primary-button fr univers-67-bold-cond ml-16"
          data-testid="replace"
        >
          {messages.replace.defaultMessage}
        </button>
        <button
          onClick={handleCancel}
          className="secondary-button fr univers-67-bold-cond"
          data-testid="replace"
        >
          {messages.cancel.defaultMessage}
        </button>
      </div>
    </Modal>
  );
};

export default DuplicateDocumentModal;
